<template>
  <card
    style="height: 100%;"
    v-loading="loading"
    element-loading-background="rgba(0, 0, 0, 0.3)"
  >
    <div class="device-picker" style="position: relative;left: 20px;">
      气象站
    </div>

    <div class="weather-data-wrap">
      <!-- <div v-if="empty" class="no-data">暂无数据</div> -->
      <div class="weather-data__card" v-for="col in cards" :key="col.key">
        <div class="weather-data__container" :style="{ background: col.bg }">
          <div class="card__value">
            <div class="value">
              <span>{{ col.value }}</span>

              <div class="unit">
                <span>{{ col.unit }}</span>
              </div>
            </div>

            <div class="label">
              <span>{{ col.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="device-picker" style="position: relative;left: 20px;">
      变化趋势
    </div>

    <echart
      chartId="meteorology"
      :options="options"
      :height="height - 250"
    ></echart>
  </card>
</template>

<script>
import mixin from '../mixin'
import Card from '../card'
import Echart from '@/components/Chart'
import { list, cols } from '@/service/meteorology'
import { subtract, add } from '@/utlis/date'
import { getIcon, colors } from '@/utlis/meteorology'
import sleep from '@/utlis/sleep'

export default {
  mixins: [mixin],
  components: { Card, Echart },
  props: { weatherKey: String, airKey: String },
  data() {
    return {
      loadingCols: false, // 初始化列数据
      loading: false,
      cols: [],
      data: {
        dataset: { source: [] },
        series: []
      },
      last: []
    }
  },
  computed: {
    dev() {
      return this.metes.find(m => m.id === this.deviceId)
    },
    deviceId() {
      if (this.weatherKey) {
        const dev = this.metes.find(m => m.key === this.weatherKey)
        return dev && dev.id
      } else {
        return ''
      }
    },
    cards() {
      return [
        'airT',
        'airH',
        'rain',
        'sunL',
        'pressure',
        'dew',
        'windS',
        'pm',
        'rad'
      ].map((k, index) => {
        const col = this.cols.find(c => c.key === k)
        const last = this.last.find(l => l.key === k)
        return {
          ...col,
          value: (last && last.value) || 0,
          bg: colors[index % colors.length]
        }
      })
    },
    options() {
      return {
        legend: {
          type: 'scroll',
          left: 52,
          right: '6%',
          bottom: 18,
          pageButtonGap: 20,
          textStyle: { color: '#9aa8d4' },
          pageTextStyle: { color: '#dcdfe6', fontSize: 14 }
        },
        tooltip: {
          transitionDuration: 0,
          formatter: params => {
            const date = params[0].value.date
            let htm = date
            params.forEach(
              ({ marker, dimensionNames, encode, seriesName, value }) => {
                htm += `</br> ${marker} ${seriesName}`
                const col = this.cols.find(c => c.name === seriesName)
                const unit = col ? (col.key === 'sunL' ? 'kLux' : col.unit) : ''

                if (!value) {
                  htm += ': -'
                } else {
                  htm += `: ${value[dimensionNames[encode.y[0]]]} ${unit}`
                }
              }
            )
            return htm
          }
        },
        grid: [
          {
            top: 48,
            left: 60,
            right: 34,
            bottom: '60%'
          },
          {
            top: '52%',
            left: 60,
            right: 34,
            bottom: 92
          }
        ],
        xAxis: [
          {
            type: 'category',
            gridIndex: 0,
            splitLine: false
          },
          {
            type: 'category',
            gridIndex: 1,
            splitLine: false
          }
        ],
        yAxis: [
          { gridIndex: 0, splitLine: { show: false } },
          { gridIndex: 0, splitLine: { show: false } },
          { gridIndex: 1, name: 'PM2.5', splitLine: { show: false } },
          { gridIndex: 1, name: '辐射', splitLine: { show: false } }
        ],
        ...this.data
      }
    }
  },
  async mounted() {
    if (this.deviceId) {
      // this.deviceId = this.metes[0].id
      await this.getCols()
      this.loading = true
      const [data] = await Promise.all([this.getData(), sleep(2)])
      this.data = data
      this.loading = false
    }
  },
  methods: {
    async getCols() {
      this.loadingCols = true
      const { data } = await cols(this.deviceId)
      this.cols = data
      this.loadingCols = false
    },
    async getData() {
      const [{ data }, last] = await Promise.all([
        list({
          companyId: this.companyId,
          deviceId: this.deviceId,
          begin: subtract(undefined, 1, 'days', 'YYYY-MM-DD 00:00:00'),
          end: add(undefined, 1, 'days', 'YYYY-MM-DD 00:00:00'),
          type: 'day'
        }),
        this.getCurData()
      ])

      this.last = last
      const keys = data.length ? this.getKeys() : []

      return {
        dataset: {
          dimensions: ['date'].concat(keys.map(c => c.key)),
          source: data.map(d => {
            d.sunL = d.sunL / 1000
            return d
          })
        },
        series: keys.map(k => {
          const card = this.cards.find(o => o.key === k.key)
          return {
            type: k.type,
            name: k.name,
            xAxisIndex: k.xIndex,
            yAxisIndex: k.yIndex,
            color: card ? card.bg : '#fff',
            symbol: 'none',
            z: k.z || 2
          }
        })
      }
    },
    async getCurData() {
      const { data } = await list({
        companyId: this.companyId,
        deviceId: this.deviceId,
        type: 'last'
      })

      return this.cols.map(c => {
        let icon = getIcon(c.name)
        return {
          ...c,
          icon: icon.icon,
          color: icon.color,
          value: data[c.key] || '-'
        }
      })
    },
    getKeys() {
      return [
        { key: 'airT', type: 'line', name: '空气温度' },
        { key: 'airH', type: 'line', name: '空气湿度', yIndex: 1 },
        { key: 'sunL', type: 'line', name: '光照强度' },
        { key: 'pressure', type: 'line', name: '气压', yIndex: 1 },
        { key: 'rain', type: 'bar', name: '降雨量' },
        // { key: 'e12', type: 'bar', name: '蒸发量' },
        {
          key: 'pm',
          type: 'line',
          name: 'PM2.5',
          xIndex: 1,
          yIndex: 2
        },
        {
          key: 'rad',
          type: 'line',
          name: '总辐射',
          xIndex: 1,
          yIndex: 3
        }
      ]
    }
  },
  watch: {
    async deviceId() {
      await this.getCols()
      this.loading = true
      const [data] = await Promise.all([this.getData(), sleep(2)])
      this.data = data
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
$height: 48px;
.weather-data-wrap {
  position: relative;
  top: 32px;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding-left: 20px;
  box-sizing: border-box;
  &:not(:last-child) {
    margin-bottom: 1.5rem;
  }
  .no-data {
    height: 112px;
    min-height: 112px;
    line-height: 112px;
  }
}
.weather-data__card {
  width: 33%;
  box-sizing: border-box;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // height: 100%;
  color: #ffffff;
  // color: '#232E44';
  padding: 0 20px 12px 0;
}
.weather-data__card:not(:last-child) {
  // padding-right: 8px;
}
.weather-data__container {
  display: flex;
  align-items: center;
  width: 100%;
  height: $height;
  background: #6ebaff;
  border-radius: 3px;
  position: relative;
  overflow: hidden;
  &:before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0.1;
    background-color: #ffffff;
  }
  &:after {
    content: '';
    background: url('~@/assets/images/card-bg.png') no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 17px;
    position: absolute;
    left: 0;
    bottom: 0;
  }
}
.card__value {
  flex: 1;
  width: 100%;
  height: $height;
  padding: 4px;
  box-sizing: border-box;
  span {
    user-select: none;
  }
}
.label {
  text-align: center;
  padding-left: 4px;
  height: 20px;
  span {
    display: inline-block;
    text-align: left;
    font-size: 14px;
    line-height: 20px;
  }
}
.value {
  text-align: center;
  span {
    color: '#232E44';
    font-size: 1rem;
  }
  .unit {
    display: inline-block;
    padding-left: 2px;
    align-items: flex-end;
    span {
      font-size: 14px;
      line-height: 20px;
    }
    &.top {
      align-self: flex-start;
    }
  }
}
</style>
